import { TagProps } from '@chakra-ui/react';
import { IconTag } from '~/common/components/IconTag/IconTag';
import { IndigoLogoSmall } from '~/common/icons';

interface PremiumTagProps
  extends Omit<TagProps, 'color' | 'variant' | 'bgColor'> {
  label?: string;
}

export const PremiumTag = ({
  label = 'Premium',
  ...props
}: PremiumTagProps) => {
  return (
    <IconTag
      color="white"
      display="inline-flex"
      fontSize="sm"
      icon={IndigoLogoSmall}
      label={label}
      letterSpacing="normal"
      px={3}
      textTransform="none"
      variant="gradient"
      {...props}
    />
  );
};
